import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum ReportSecurityRight {
    CanAccess = 8000,
    Manage = 8001,
}

export class ReportSecurityModule extends BaseSecurityModule<ReportSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Reports,
            [
                { _id: ReportSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: ReportSecurityRight.Manage, name: 'Manage', basic: true },
            ] as SecurityRight<ReportSecurityRight>[]
        );
    }


}
